import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Media from 'react-media';
import classes from './Layout.scss';

// Side Navigation, Article(Booking Engine), Content(Main Area)
import SideNavigation from '../../components/Navigation/SideNavigation/SideNavigation';
import Content from '../../containers/Content/Content';
import Article from '../../containers/Article/Article';

import Home from '../../containers/Home/Home';
import Flights from '../../containers/Flights/Flights';
import Hotels from '../../containers/Hotels/Hotels';
import Authentication from '../../containers/Authentication/Authentication';
import AuthSetPassword from '../../components/Authentication/AuthSetPassword/AuthSetPassword';

// Booking Engine
import BookingEngineFlight from '../../containers/FlightBookingEngine/FlightBookingEngine';
import BookingEngineHotel from '../../containers/HotelBookingEngine/HotelBookingEngine';
import MobileHome from '../../components/Mobile/MobileHome/MobileHome';

import SwitchWithSlide from '../../containers/SwitchWithSlide/SwitchWithSlide';

import EnsureLoggedInContainer from '../../containers/EnsureLoggedInContainer/EnsureLoggedInContainer';


// const Home = React.lazy(() => import('../../containers/Home/Home'));
// const Flights = React.lazy(() => import('../../containers/Flights/Flights'));
// const Hotels = React.lazy(() => import('../../containers/Hotels/Hotels'));
// const TrainTuple = React.lazy(() => import('../../components/Trains/TrainTuple/TrainTuple'));
// const User = React.lazy(() => import('../../containers/User/User'));
// const Authentication = React.lazy(() => import('../../containers/Authentication/Authentication'));
// const AuthSetPassword = React.lazy(() => import('../../components/Authentication/AuthSetPassword/AuthSetPassword'));

class Layout extends Component {

    render() {

        return (
            <div className={`${classes.Wrapper} u-flex f-row u-transitionAll300Ease`}>
                <Media query="(max-width: 599px)">
                    {matches =>
                        matches ? (
                            <React.Fragment>
                                <SideNavigation />
                                <Content>
                                    <Switch>
                                        <Route exact path="/" component={Authentication}/>
                                        <Route path="/auth/set_password" component={AuthSetPassword} />
                                        <Route path="/flight" component={MobileHome}/>
                                        <EnsureLoggedInContainer>
                                            <Route path='/flights/search' component={Flights}/>
                                            <Route exact path='/flights' component={BookingEngineFlight}/>
                                            <Route path="/hotels/search" component={Hotels} />
                                            <Route exact path='/hotels' component={BookingEngineHotel}/>
                                        </EnsureLoggedInContainer>
                                    </Switch>
                                </Content>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <SideNavigation />
                                <div className={`u-flex f-column u-width100Percent`}>
                                    <div className={`u-flex`}>
                                        <Article>
                                            <Switch>
                                                <Route exact path="/" component={BookingEngineFlight}/>
                                                <Route path="/auth/set_password" component={AuthSetPassword} />
                                                    <Route path='/user' component={BookingEngineFlight}/>
                                                    <Route path='/flight' render={() => <Redirect to='/flights' />}/>
                                                    <Route path='/flights' component={BookingEngineFlight}/>
                                                    <Route path='/hotels' component={BookingEngineHotel}/>
                                            </Switch>
                                        </Article>
                                        <Content>
                                            <Switch>
                                                <Route exact path="/" component={Home} />
                                                {/* <Route path='/auth/set_password' component={Home}/> */}
                                                    <Route path='/flights/search' component={Flights}/>
                                                    <Route path='/flight' render={() => <Redirect to='/flights' />}/>
                                                    <Route exact path='/flights' component={Home}/>
                                                    <Route path='/hotels/search' component={Hotels}/>
                                                    <Route exact path="/hotels" component={Home} />
                                            </Switch>
                                        </Content>
                                    </div>
                                </div>
                            </React.Fragment>
                        )
                    }
                </Media>
            </div>
        );
    }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js